import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PtlWindowLocationService } from '@ptl/global-components';
import { MessagesResponseStructure } from '../message-catalog-modal-trigger/interfaces/message-catalog-modal.interface';

@Component({
  selector: 'app-message-catalog-modal',
  templateUrl: './message-catalog-modal.component.html',
  styleUrl: './message-catalog-modal.component.scss',
  standalone: false
})
export class MessageCatalogModalComponent {

  constructor(
    private dialogRef: MatDialogRef<MessageCatalogModalComponent>,
    private windowLocationService: PtlWindowLocationService,
    @Inject(MAT_DIALOG_DATA) public data: {
      modalHeading: string,
      rightButtonLabel: string,
      newTabRightButtonUrl: boolean,
      rightButtonRedirectUrl: string,
      showLeftButton: boolean,
      leftButtonLabel: string,
      newTabLeftButtonUrl: boolean,
      leftButtonRedirectUrl: string,
      emphasizedText: string,
      displayPage: string,
      responseForDisplay: MessagesResponseStructure[]
    }
  ){}

  buttonClicked(buttonSide: 'right' | 'left'){
    if(buttonSide === 'right'){
      if(this.data.rightButtonRedirectUrl){
        this.windowLocationService.goToUrl(this.data?.rightButtonRedirectUrl, { newTab: this.data.newTabRightButtonUrl });
        if(this.data.newTabRightButtonUrl) { this.dialogRef.close(); }
      }
    }else if(buttonSide === 'left'){
      if(this.data.leftButtonRedirectUrl){
        this.windowLocationService.goToUrl(this.data?.leftButtonRedirectUrl, { newTab: this.data.newTabLeftButtonUrl })
        if(this.data.newTabLeftButtonUrl) { this.dialogRef.close(); }
      }
    }
    //close if no url is provided for clicked button
    this.dialogRef.close();
  }
}
